import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyBlogTags } from "../../api/apiBlogTags";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي لوسوم المدونة (soft delete)
 */
export function useDeleteAllBlogTags() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllBlogTagsMutate,
        isPending,
    } = useMutation({
        mutationFn: massDestroyBlogTags,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-tags"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete blog tags");
        },
    });

    return {
        deleteAllBlogTagsMutate,
        isPending,
    };
}
